// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalInput_wrapper__pOxte"};